export const listingsSelector = (state: any) => state.user.listings;
